import { render, staticRenderFns } from "./IndexList.vue?vue&type=template&id=5c5e9330&scoped=true&"
import script from "./IndexList.vue?vue&type=script&lang=js&"
export * from "./IndexList.vue?vue&type=script&lang=js&"
import style0 from "./IndexList.vue?vue&type=style&index=0&id=5c5e9330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e9330",
  null
  
)

export default component.exports